export interface MangaCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export interface MangaWork {
  id: number;
  title: string;
  author: string;
  category: string;
  coverSeq: string;
  rating: number;
  views: number;
  description: string;
  tags: string[];
  updateDate: string;
  chapters: number;
  status: '连载中' | '已完结';
  featured: boolean;
  content: string;
  highlights: string[];
}

export const categories: MangaCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', description: '浏览所有分类的黄漫作品', count: 1256 },
  { slug: 'campus', name: '校园青春', icon: 'ri-book-open-line', description: '校园恋爱与青春故事', count: 234 },
  { slug: 'office', name: '职场OL', icon: 'ri-briefcase-line', description: '职场女性与办公室故事', count: 189 },
  { slug: 'fantasy', name: '奇幻异世界', icon: 'ri-rocket-line', description: '异世界冒险与奇幻旅程', count: 312 },
  { slug: 'romance', name: '纯爱言情', icon: 'ri-heart-line', description: '浪漫纯爱故事合集', count: 278 },
  { slug: 'action', name: '热血战斗', icon: 'ri-sword-line', description: '热血战斗与冒险题材', count: 156 },
  { slug: 'slice-of-life', name: '日常治愈', icon: 'ri-sun-line', description: '温馨日常与治愈系作品', count: 203 },
  { slug: 'mature', name: '成熟向', icon: 'ri-vip-crown-line', description: '面向成人读者的深度作品', count: 145 },
  { slug: 'doujin', name: '同人创作', icon: 'ri-paint-brush-line', description: '优秀同人创作合集', count: 198 },
];

export const mangaWorks: MangaWork[] = [
  {
    id: 1,
    title: '暗夜迷情',
    author: '墨染青衣',
    category: 'romance',
    coverSeq: 'dark-night-romance-001',
    rating: 9.6,
    views: 258000,
    description: '在繁华都市的暗夜中，两个孤独灵魂相遇相知，展开一段充满激情与纠葛的爱情故事。画风精美细腻，剧情扣人心弦。',
    tags: ['纯爱', '都市', '情感', '治愈'],
    updateDate: '2026-08-07',
    chapters: 128,
    status: '连载中',
    featured: true,
    content: '夜深了，城市的霓虹灯在窗外闪烁。林小曼独自站在公寓的阳台上，手中握着一杯已经凉透的咖啡。她刚刚结束了一段长达三年的感情，心里空落落的，像是被掏走了一块。\n\n就在这个夜晚，她遇见了陈默——一个同样在深夜无法入眠的男人。他们在便利店偶遇，两人的手同时伸向最后一罐热咖啡。\n\n"你也是睡不着吗？"陈默问道，声音低沉而温柔。\n\n林小曼抬头看向他，那是一双深邃如夜空的眼眸，仿佛藏着无数未说出口的故事。\n\n从那一夜开始，他们的命运紧紧交织在了一起...',
    highlights: ['细腻的情感描写', '精致的画风呈现', '引人入胜的剧情发展', '深刻的人物刻画'],
  },
  {
    id: 2,
    title: '禁忌之恋',
    author: '夜雨声烦',
    category: 'mature',
    coverSeq: 'forbidden-love-002',
    rating: 9.4,
    views: 312000,
    description: '一段被世俗所不容的恋情，在禁忌的边缘燃烧。当理智与欲望碰撞，当道德与情感交锋，他们将何去何从？',
    tags: ['禁忌', '成人', '情感', '剧情'],
    updateDate: '2026-08-06',
    chapters: 96,
    status: '连载中',
    featured: true,
    content: '结婚五周年的纪念日，周婉清却在老公的手机里发现了不该看到的东西。那一刻，她的世界崩塌了。\n\n她以为自己拥有完美的婚姻——事业有成的丈夫、可爱的女儿、温馨的家。可这一切，原来都只是她一厢情愿的幻象。\n\n在最低落的时候，她遇见了比自己小七岁的苏航。他阳光、热情，像一束光穿透了她灰暗的世界。明知不该，明知危险，她却无法控制自己一步步靠近...',
    highlights: ['大胆的题材探索', '成熟的情感表达', '社会议题的深度思考', '扣人心弦的叙事节奏'],
  },
  {
    id: 3,
    title: '樱花树下的约定',
    author: '月下独酌',
    category: 'campus',
    coverSeq: 'sakura-promise-003',
    rating: 9.5,
    views: 196000,
    description: '高中三年级的春天，樱花纷飞的校园里，一段青涩而美好的初恋悄然绽放。这是关于青春、梦想和约定的故事。',
    tags: ['校园', '青春', '初恋', '纯爱'],
    updateDate: '2026-08-05',
    chapters: 72,
    status: '已完结',
    featured: false,
    content: '又是一年樱花季。\n\n高三（3）班的教室窗外，粉色的花瓣纷纷扬扬，像是一场温柔的雪。叶芷晴坐在靠窗的位置，目光却不自觉地飘向斜前方的那个背影。\n\n他叫顾北辰，是年级第一的学霸，也是她暗恋了两年的人。\n\n"叶芷晴，你愿意和我考同一所大学吗？"\n\n当顾北辰在樱花树下说出这句话时，整个世界仿佛都安静了下来。只剩下花瓣飘落的声音，和她心跳如鼓的声响...',
    highlights: ['纯真的青春回忆', '唯美的校园场景', '温暖人心的故事', '精致的画面表现'],
  },
  {
    id: 4,
    title: '异世界后宫物语',
    author: '幻想旅人',
    category: 'fantasy',
    coverSeq: 'isekai-harem-004',
    rating: 9.2,
    views: 445000,
    description: '普通上班族意外穿越到剑与魔法的异世界，却发现自己拥有特殊能力。在冒险的旅途中，他与多位美少女邂逅，展开一段波澜壮阔的异世界后宫传奇。',
    tags: ['异世界', '后宫', '冒险', '魔法'],
    updateDate: '2026-08-07',
    chapters: 156,
    status: '连载中',
    featured: true,
    content: '"我...这是在哪里？"\n\n李浩然睁开眼，映入眼帘的是一片从未见过的奇幻森林。巨大的树木直插云霄，空气中弥漫着魔力的波动。\n\n更离谱的是，他身边躺着一个银发精灵少女，正用那双翡翠般的眼眸好奇地打量着他。\n\n"你是...召唤来的勇者大人吗？"\n\n就这样，一个普通程序员的异世界冒险，意外地开始了。他不仅获得了超乎想象的魔法天赋，还接二连三地邂逅了精灵公主、猫耳兽娘、傲娇魔法师...',
    highlights: ['宏大的世界观构建', '丰富的角色塑造', '精彩的战斗场面', '幽默的日常互动'],
  },
  {
    id: 5,
    title: '社长大人请自重',
    author: '咖啡不加糖',
    category: 'office',
    coverSeq: 'president-please-005',
    rating: 9.3,
    views: 278000,
    description: '初入职场的新人助理，遇到了冷酷霸道的社长。白天是严厉的上司，夜晚却展现出截然不同的温柔。办公室恋情的甜蜜与刺激，让人欲罢不能。',
    tags: ['职场', '恋爱', '总裁', '甜宠'],
    updateDate: '2026-08-04',
    chapters: 88,
    status: '连载中',
    featured: false,
    content: '第一天上班，苏小念就在全公司面前出了个大糗——她把咖啡泼在了社长大人价值六位数的西装上。\n\n"你被开除了。"冷冰冰的声音从头顶传来。\n\n苏小念差点当场哭出来。这可是她好不容易才得到的工作啊！\n\n然而第二天，人事部通知她去社长办公室报到——做社长的私人助理。\n\n"为什么是我？"\n\n社长陆景琛头也不抬："因为你欠我一套西装。"\n\n从此，苏小念的职场生活变得鸡飞狗跳，却又甜蜜无比...',
    highlights: ['反差萌的人物设定', '甜到爆的互动情节', '真实的职场氛围', '轻松幽默的叙事'],
  },
  {
    id: 6,
    title: '血月狂刀',
    author: '龙战于野',
    category: 'action',
    coverSeq: 'blood-moon-blade-006',
    rating: 9.1,
    views: 389000,
    description: '在一个被妖魔肆虐的世界里，少年剑客背负血海深仇，踏上了一条充满杀戮与救赎的复仇之路。热血激战，一触即发！',
    tags: ['战斗', '热血', '武侠', '复仇'],
    updateDate: '2026-08-06',
    chapters: 112,
    status: '连载中',
    featured: false,
    content: '那一夜，满月如血。\n\n十五岁的林战眼睁睁看着整个林家被妖魔屠戮殆尽，而他却因为年幼无力而被藏在地窖中苟活。\n\n十年后，他带着一把名为"血月"的古刀重返江湖。每一刀斩出的都是十年来的愤怒与仇恨。\n\n但当他逐渐接近真相时，却发现那场灭门惨案背后隐藏着更大的阴谋...',
    highlights: ['酣畅淋漓的战斗分镜', '宏大壮阔的世界设定', '深刻的人物成长', '反转不断的剧情'],
  },
  {
    id: 7,
    title: '邻家姐姐是恶魔',
    author: '甜橙味汽水',
    category: 'slice-of-life',
    coverSeq: 'neighbor-devil-007',
    rating: 9.0,
    views: 167000,
    description: '搬来新家的第一天，我就发现隔壁住着一个超级漂亮的姐姐。然而她的真实身份，却是一个来自地狱的恶魔？温馨搞笑的日常同居生活，就此开始！',
    tags: ['日常', '搞笑', '治愈', '恋爱'],
    updateDate: '2026-08-03',
    chapters: 64,
    status: '连载中',
    featured: false,
    content: '"你好，我是住在隔壁的莉莉丝，请多关照。"\n\n张小白看着眼前这位金发碧眼、身材火辣的美女姐姐，整个人都呆住了。\n\n然而当天晚上，他不小心从阳台看到了一个惊人的画面——这位温柔的姐姐背后展开了一对漆黑的翅膀，手中还拿着一把燃烧的三叉戟。\n\n"啊，被你看到了呢。"莉莉丝转过头，露出一个危险而迷人的微笑。\n\n张小白的人生，从这一刻起变得天翻地覆...',
    highlights: ['轻松搞笑的日常', '反差萌的角色设定', '温暖治愈的内核', '精美的日常场景'],
  },
  {
    id: 8,
    title: '同人乐园',
    author: '绘梦师小陈',
    category: 'doujin',
    coverSeq: 'doujin-paradise-008',
    rating: 9.3,
    views: 234000,
    description: '精选热门动漫、游戏同人创作合集。各路绘师倾情奉献，带你领略不同视角下的经典角色与故事。创意无限，精彩纷呈。',
    tags: ['同人', '二次元', '合集', '创作'],
    updateDate: '2026-08-07',
    chapters: 45,
    status: '连载中',
    featured: false,
    content: '同人创作是二次元文化中最闪耀的珍珠。\n\n本合集收录了来自百位优秀同人画师的精选作品，涵盖当下最热门的动漫、游戏IP。每一位画师都以自己独特的视角和风格，重新诠释了那些我们深爱的角色和故事。\n\n无论是甜蜜的恋爱剧情，还是热血的战斗场面，亦或是温馨的日常片段，这里应有尽有。让我们一起沉浸在创作者的奇思妙想之中吧！',
    highlights: ['多元化创作风格', '高质量画作呈现', '丰富的题材覆盖', '创作者独家专访'],
  },
  {
    id: 9,
    title: '魔法学院纪事',
    author: '星尘轨迹',
    category: 'fantasy',
    coverSeq: 'magic-academy-009',
    rating: 9.5,
    views: 298000,
    description: '在古老的魔法学院中，少年少女们学习魔法、探索未知、经历成长。友情、爱情与冒险交织，谱写出一段段动人的魔法学院纪事。',
    tags: ['魔法', '学院', '成长', '恋爱'],
    updateDate: '2026-08-06',
    chapters: 104,
    status: '连载中',
    featured: true,
    content: '圣罗兰魔法学院，大陆上最负盛名的魔法学府。\n\n每年只有最优秀的一百名学员能够获得入学资格。沈星辰，一个来自偏远乡村的少年，凭借惊人的魔法天赋获得了入学机会。\n\n在这里，他遇到了形形色色的同伴——傲娇的贵族千金、沉默寡言的天才剑士、活泼开朗的精灵少女、神秘莫测的转学生。\n\n七个性格迥异的少年少女，在魔法学院中共同成长，谱写属于他们的青春物语...',
    highlights: ['完整的魔法体系设定', '七位主角的群像描写', '学园生活的真实还原', '宏大的世界观铺垫'],
  },
  {
    id: 10,
    title: '深夜食堂·成人版',
    author: '老饕漫笔',
    category: 'mature',
    coverSeq: 'midnight-diner-adult-010',
    rating: 9.7,
    views: 356000,
    description: '一家只在深夜营业的隐秘食堂，每位客人都带着自己的故事而来。美食与情欲交织，在舌尖与心间同时绽放的极致体验。',
    tags: ['美食', '情感', '成人', '都市'],
    updateDate: '2026-08-07',
    chapters: 82,
    status: '连载中',
    featured: true,
    content: '城南老巷深处，有一家没有招牌的小店。\n\n它只在午夜十二点后开门，天亮前打烊。老板是个沉默寡言的中年男人，没人知道他的名字，大家都叫他"厨子"。\n\n这里的规矩很简单：可以点任何你想吃的菜，但如果老板愿意做，你必须分享你的故事作为交换。\n\n于是，形形色色的人带着各自的故事来到这间深夜食堂——失恋的女人、事业受挫的男人、迷茫的年轻人...在这里，美食成为治愈心灵的良药，而深夜的氛围也让人们卸下防备，坦诚相见。',
    highlights: ['独特的故事结构', '美食与情感的完美融合', '成人世界的真实描写', '电影级的分镜呈现'],
  },
  {
    id: 11,
    title: '夏日补习班',
    author: '橘子汽水',
    category: 'campus',
    coverSeq: 'summer-cram-011',
    rating: 8.9,
    views: 145000,
    description: '炎炎夏日，被父母强制送去补习班的高中生们，在枯燥的学习中找到了属于彼此的快乐。这是一个关于青春、友情和秘密的夏日物语。',
    tags: ['校园', '青春', '搞笑', '群像'],
    updateDate: '2026-08-02',
    chapters: 56,
    status: '已完结',
    featured: false,
    content: '"为什么要我暑假来补习啊！"\n\n五个来自不同班级的高中生，因为各自的原因被送进了暑期补习班。数学、英语、物理——每一门课都让他们昏昏欲睡。\n\n然而，当他们开始互相认识，补习班变成了一个秘密基地。他们一起逃课去看电影，一起在天台上吃西瓜，一起分享各自的烦恼和秘密。\n\n这个夏天，注定是他们青春中最难忘的回忆...',
    highlights: ['真实的青春气息', '群像角色的精彩互动', '搞笑又温馨的剧情', '夏日氛围感满分'],
  },
  {
    id: 12,
    title: '女帝的秘密',
    author: '紫禁流云',
    category: 'romance',
    coverSeq: 'empress-secret-012',
    rating: 9.4,
    views: 267000,
    description: '大周朝唯一的女帝，白天治理天下，夜晚却有一个不为人知的秘密——她爱上了一个来自民间的男子。权谋与爱情交织，宫廷深处的禁忌之恋。',
    tags: ['古风', '宫廷', '权谋', '恋爱'],
    updateDate: '2026-08-05',
    chapters: 92,
    status: '连载中',
    featured: false,
    content: '大周永平三年，女帝慕容清霜登基。\n\n朝堂之上，她是杀伐果断的帝王；深宫之中，她却有着一颗渴望平凡爱情的心。\n\n在一次微服私访中，她遇见了一个叫苏瑾的画师。他不知她的身份，只当她是一个来求画的普通女子。两人一见如故，从此开始了秘密的书信往来。\n\n然而，宫廷的暗流涌动，各方势力虎视眈眈。这段跨越阶级的感情，注定不会一帆风顺...',
    highlights: ['大气磅礴的宫廷场景', '权谋与爱情的双线叙事', '生动的人物群像', '精美的古风画面'],
  },
];

export const featuredAuthors = [
  { name: '墨染青衣', avatarSeq: 'author-ink-001', works: 15, followers: 128000, specialty: '情感纯爱' },
  { name: '夜雨声烦', avatarSeq: 'author-night-002', works: 12, followers: 156000, specialty: '成熟向' },
  { name: '幻想旅人', avatarSeq: 'author-fantasy-003', works: 20, followers: 210000, specialty: '奇幻冒险' },
  { name: '月下独酌', avatarSeq: 'author-moon-004', works: 8, followers: 89000, specialty: '校园青春' },
  { name: '咖啡不加糖', avatarSeq: 'author-coffee-005', works: 10, followers: 112000, specialty: '职场恋爱' },
  { name: '龙战于野', avatarSeq: 'author-dragon-006', works: 18, followers: 198000, specialty: '热血战斗' },
];